<div class="card-qr-scanner" *transloco="let t; read:'permit.team.search.cardQrScannerBA'">
    <zxing-scanner #scanner class="card-qr-scanner__scanner" [formats]="allowedFormats" [torch]="isTorchOn" (torchCompatible)="torchCompatibleHandler($event)"
                   (camerasFound)="camerasFoundHandler($event)" (camerasNotFound)="camerasNotFoundHandler($event)" (scanSuccess)="scanSuccessHandler($event)"
                   (scanError)="scanErrorHandler($event)" (scanFailure)="scanFailureHandler($event)" (scanComplete)="scanCompleteHandler($event)">
    </zxing-scanner>
    
    <!-- <fast-qr-component (scan)="scanSuccessHandler($event)"></fast-qr-component> -->

    <div class="card-qr-scanner__cameras" *ngIf="canChangeCamera">
        <div class="card-qr-scanner__cameras__camera" *ngFor="let camera of cameras" [ngClass]="{'card-qr-scanner__cameras__camera--selected': camera.deviceId === activeCamera?.deviceId}" (click)="changeCamera(camera.deviceId)">
            {{camera.label}}
        </div>
    </div>

    <div class="card-qr-scanner__content">
        <!-- <button class="card-qr-scanner__content__change-camera-button" *ngIf="canChangeCamera" (click)="changeCamera()">{{ t("changeCamera") }}</button> -->
        <button class="card-qr-scanner__content__toggle-torch-button" *ngIf="isTorchCompatible" (click)="toggleTorch()">{{ t("toggleTorch") }}</button>
    </div>
</div>
